import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ServiceShowcase } from "@/components/ServiceShowcase";
import { BrandPatternLayer } from "@/components/BrandPatternLayer";
import { pageContent } from "@/cms/cmsModel";
import { useCmsDocument } from "@/cms/CmsContentProvider";

// Partnernetzwerk is kept as the OVERVIEW page: it presents the four service
// areas as cards (title, short description, icon, "Mehr erfahren") that link to
// the dedicated service pages (/gutachten, /versicherung, /kfz-zulassung,
// /services).
export default function Partnernetzwerk() {
  useCmsDocument();
  const copy = pageContent.partner;
  return (
    <div data-testid="partnernetzwerk-page">
      {/* Hero – full-bleed brand image with a neutral (non-blue) scrim */}
      <section className="relative flex min-h-[440px] items-center overflow-hidden bg-[#0e1216] text-[#F1F4F8] lg:min-h-[520px]">
        <img
          src={copy.hero.image}
          alt={copy.hero.alt}
          loading="eager"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, rgba(12,16,20,0.82) 0%, rgba(12,16,20,0.62) 32%, rgba(12,16,20,0.28) 60%, rgba(12,16,20,0.05) 100%)",
          }}
        />
        <div className="relative az-container py-16 lg:py-20">
          <Reveal immediate>
            <span className="az-eyebrow" style={{ color: "#C99A3D" }}>
              <span className="inline-block h-px w-6 bg-current" /> {copy.hero.eyebrow}
            </span>
          </Reveal>
          <Reveal immediate delay={0.05}>
            <h1 className="mt-4 max-w-3xl font-heading text-4xl font-bold leading-[1.08] tracking-[-0.02em] sm:text-5xl lg:text-6xl">
              {copy.hero.title}
            </h1>
          </Reveal>
          <Reveal immediate delay={0.1}>
            <p className="mt-5 max-w-2xl text-lg text-[rgba(244,246,249,0.82)]">
              {copy.hero.subtitle}
            </p>
          </Reveal>
        </div>
      </section>

      {/* Overview cards → dedicated service pages */}
      <section
        className="relative isolate overflow-hidden bg-[#F1F4F8]/90 py-16 lg:py-24"
        data-testid="partnernetzwerk-overview"
      >
        <BrandPatternLayer variant="corporate" composition="a" />
        <div className="relative z-10 az-container">
          <SectionHeading
            eyebrow={copy.heading.eyebrow}
            title={copy.heading.title}
            subtitle={copy.heading.subtitle}
          />
          <div className="mt-10">
            <ServiceShowcase />
          </div>
        </div>
      </section>
    </div>
  );
}
